var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMetaLoginPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 0C4.55625 0 2.4 2.15625 2.4 4.8V6H1.8C0.810937 6 0 6.81094 0 7.8V13.8C0 14.7891 0.810937 15.6 1.8 15.6H12.6C13.5891 15.6 14.4 14.7891 14.4 13.8V7.8C14.4 6.81094 13.5891 6 12.6 6H12V4.8C12 2.15625 9.84375 0 7.2 0ZM7.2 1.2C9.19688 1.2 10.8 2.80313 10.8 4.8V6H3.6V4.8C3.6 2.80313 5.20313 1.2 7.2 1.2ZM1.8 7.2H12.6C12.9375 7.2 13.2 7.4625 13.2 7.8V13.8C13.2 14.1375 12.9375 14.4 12.6 14.4H1.8C1.4625 14.4 1.2 14.1375 1.2 13.8V7.8C1.2 7.4625 1.4625 7.2 1.8 7.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaLoginPass);
export default __webpack_public_path__ + "static/media/meta-login-pass.6b3fe6caea99733971ee382f9dab93ed.svg";
export { ForwardRef as ReactComponent };